import { Serializable } from '@/models/core/serializable';
import { Tag } from '@/models/tag';

export class SchoolGroup implements Serializable<SchoolGroup> {
  createdAt: string;
  memo: string;
  name: string;
  registrationCount: number;
  schoolGroupID: number;
  tags: Tag[];

  deserialize(input: any): SchoolGroup {
    this.createdAt = input.createdAt;
    this.memo = input.memo;
    this.name = input.name;
    this.registrationCount = input.registrationCount;
    this.schoolGroupID = input.schoolGroupID;
    this.tags = input.tags.map((tag: any) => new Tag().deserialize(tag));
    return this;
  }
  get showTags(): string {
    if (this.tags && this.tags.length > 0) {
      return this.tags.map((tag: Tag) => tag.tagContent).join('|');
    } else {
      return '';
    }
  }
}
